const LOCAL_TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;
export function isValidLocalTime(value) {
    return LOCAL_TIME_PATTERN.test(value);
}
/** Parses HH:mm into minutes since midnight. */
export function localTimeToMinutes(value) {
    if (!isValidLocalTime(value)) {
        throw new Error(`Invalid local time: ${value}`);
    }
    const hour = Number(value.slice(0, 2));
    const minute = Number(value.slice(3, 5));
    return hour * 60 + minute;
}
export function isValidDayOfWeek(value) {
    return Number.isInteger(value) && value >= 0 && value <= 6;
}
export function assertDaysOfWeek(daysOfWeek) {
    const seen = new Set();
    for (const day of daysOfWeek) {
        if (!isValidDayOfWeek(day)) {
            throw new Error(`Invalid day of week: ${day}`);
        }
        if (seen.has(day)) {
            throw new Error(`Duplicate day of week: ${day}`);
        }
        seen.add(day);
    }
}
//# sourceMappingURL=local-time.js.map